import { render, staticRenderFns } from "./PermissionDocPB.vue?vue&type=template&id=b171fdfc&scoped=true&"
import script from "./PermissionDocPB.vue?vue&type=script&lang=js&"
export * from "./PermissionDocPB.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDocPB.vue?vue&type=style&index=0&id=b171fdfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b171fdfc",
  null
  
)

export default component.exports